//https://stackoverflow.com/questions/11556110/signalr-and-mvc-bundle
//prima c'era <script src="~/signalr/hubs"></script>
//in layout.cshtml
//requires abp.appPath = '@ApplicationPath'; to be set
(function ($) {
    $.ajax({
        url: abp.appPath + "signalr/hubs",
        dataType: "script",
        async: false
    });
}(jQuery));